import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Recording problems</div>
                                            <p>Record any problems during the project. The cause, when it
                                                happened, its impact on the progress
                                                and whether and how it was resolved. When evaluating the project
                                                after its close, a record of any
                                                problems will help you learn and refine future projects.</p>
                                            <div className="border_subtitle">User acceptance testing (UAT)</div>
                                            <p>As each key milestone is reached, check that any deliverables so
                                                far meet acceptable standards.
                                                For example, if you’re developing a website for a client, ask
                                                them for an appraisal (UAT) at each
                                                milestone so that amendments can be easily incorporated. If this
                                                is left until later on, alterations
                                                may be much more difficult and have more impact on other aspects
                                                of the project.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>SELLING YOUR STRENGTHS
                                            </div>
                                            <p>The following exercise will make you more aware of the best way
                                                for you to win and manage
                                                resources, according to your preferred methods of working – or
                                                to ensure you ‘play to your
                                                strengths’ and operate as effectively as possible. There are
                                                more, but we’ll focus on the eleven
                                                working styles and strengths which relate to most of us.</p>
                                            <div className="border_subtitle">Exercise: Using your strengths to
                                                win resources
                                            </div>
                                            <p>Using the table below, identify what strengths<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>6</sup></a> you think
                                                you have and how you could use them
                                                to win resources for a particular project.</p>
                                            <div className="desktop ipad-portrait-show">
                                                <table
                                                    className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left"
                                                            valign="center" width="10%">Strength
                                                        </th>
                                                        <th align="left" valign="center"
                                                            width="20%">Characterised by…
                                                        </th>

                                                        <th className=" green_curve1" align="left"
                                                            valign="center" width="20%">How to use it…
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Analyser
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You need evidence and proof
                                                            for assertions and to
                                                            understand broad implications.</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Analyse any information you have to
                                                            prove the
                                                            relevance of your project; for example, how it can
                                                            improve sales figures. Your analytical nature will
                                                            enable you to build a strong business case using
                                                            facts and figures. The organisation will be keen
                                                            to see what impact you can have on the bottom
                                                            line. However, be careful not to forget the
                                                            ‘people’ side of things.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Values driven
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Strong beliefs in values and
                                                            ethics. Easy to trust.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Show how your project benefits the
                                                            company
                                                            while complying with or reinforcing its values.
                                                            However, don’t forget to make your argument
                                                            practical and commercial. </p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%">Communicator
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You like to enliven your ideas
                                                            by using stories and images
                                                            to capture the imagination
                                                            of others.</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Use your excellent communication
                                                            skills to
                                                            persuade others. Using a story is a good way of
                                                            bringing your pitch to life and making it
                                                            memorable. Use these skills to make your
                                                            requests easy to understand and relate to.
                                                            However, be careful not to appear to be relying
                                                            on theory alone. Use some facts and figures,
                                                            too.</p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%">Risk avoider
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You are careful, vigilant and
                                                            risk averse. You like to identify
                                                            the risks in life, assess them
                                                            and think about how they
                                                            can be minimised. You like to
                                                            plan ahead.</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Your preference for planning and
                                                            minimising risks
                                                            could be a real strength when winning resources.
                                                            Before pitching for your resources carefully plan
                                                            out your project, identify your risks and how you
                                                            will manage them. Presenting your information in
                                                            a structured way will show you as well organised.
                                                            However, be careful not to appear to lack
                                                            imagination or be unreceptive to new suggestions
                                                            and innovations.</p>
                                                        </td>

                                                    </tr>

                                                    </tbody>
                                                </table>

                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="darkgreen"
                                                            id="yui_3_17_2_1_1516011044300_28"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Analyser
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You need evidence and proof
                                                            for assertions and to
                                                            understand broad implications.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" valign="top" width="20%"><p>Analyse any
                                                            information you have to prove the
                                                            relevance of your project; for example, how it can
                                                            improve sales figures. Your analytical nature will
                                                            enable you to build a strong business case using
                                                            facts and figures. The organisation will be keen
                                                            to see what impact you can have on the bottom
                                                            line. However, be careful not to forget the
                                                            ‘people’ side of things.</p>
                                                        </td>

                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Values driven
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Strong beliefs in values and ethics.
                                                            Easy to trust.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>Show how your project benefits the company while
                                                                complying with or reinforcing its values.
                                                                However, don’t forget to make your argument
                                                                practical and commercial. </p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="darkgreen"
                                                            id="yui_3_17_2_1_1516011044300_28"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Communicator
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>You like to enliven your ideas by
                                                            using stories and images to capture the imagination
                                                            of others.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="darkgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" valign="top" width="20%">
                                                            <p>Show how your project benefits the company while
                                                                complying with or reinforcing its values.
                                                                However, don’t forget to make your argument
                                                                practical and commercial. </p>
                                                        </td>

                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Strength</th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}} align="left"
                                                            width="10%" valign="top">Risk avoider
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th align="left" valign="top" width="20%">Characterised
                                                            by…
                                                        </th>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>You are careful, vigilant and risk
                                                            averse. You like to identify the risks in life,
                                                            assess them and think about how they can be
                                                            minimised. You like to plan ahead.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className=" darkgreen"
                                                            style={{borderBottomLeftRadius: '15px'}}
                                                            align="left" width="20%" valign="top">How to use it…
                                                        </th>
                                                        <td className="lightgreen"
                                                            style={{borderBottomRightRadius: '15px'}}
                                                            align="left" width="20%" valign="top">
                                                            <p>Your preference for planning and minimising risks
                                                                could be a real strength when winning resources.
                                                                Before pitching for your resources carefully
                                                                plan out your project, identify your risks and
                                                                how you will manage them. Presenting your
                                                                information in a structured way will show you as
                                                                well organised. However, be careful not to
                                                                appear to lack imagination or be unreceptive to
                                                                new suggestions and innovations.</p>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>


                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}